import { Disclosure} from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'

const faqs = [
  {
    question: "Welche Datei-Formate unterstützt der XPlanung24 Viewer?",
    answer:
        "Aktuell unterstützten wir ausschließlich XPlan konforme GML Datein um Viewer. Spiral oder CAD Daten sowie ZIP Dateien werden nicht unterstützt.",
  },{
    question: "Gibt es eine Limitierung in der Datei Größe?",
    answer:
        "Aktuell können XPläne bis zu 40mb pro Plan dargestellt werden. Die Verarbeitung und Darstellung kann aber zu längeren Ladezeiten Führen.",
  },{
    question: "Welche XPlan Versionen unterstützt der Viewer?",
    answer:
        "Der Viewer unterstützt XPläne in den Versionen: 5.x bis 6.0.2",
  }

]

export const HelpPage = () => {
  return (
      <div className='mx-auto w-full sm:max-w-7xl'>
          <div
              className={
                  'text-base m-5 mt-[30px] mb-12 leading-7 text-gray-600'
              }>
              <div className='mt-2 flex flex-col sm:flex-row items-center sm:justify-between'>
                  <div className='min-w-0 flex flex-1'>
                      <h2 className='w-full text-xl truncate sm:mb-0 mb-4 lg:text-2xl textShadow flex font-normal leading-7 text-gray-900 sm:truncate  sm:tracking-tight'>
                          Hilfe-Center
                      </h2>
                  </div>
              </div>
          </div>
          <div className={'border border-gray-500 rounded-lg  w-full bg-white mb-12'}>


              <div className='gap-3  divide-y divide-gray-300 '>

                  <div className="p-4 lg:p-6">
                      <h3 className="text-lg font-semibold text-gray-900">Fragen zu XPlanung24</h3>
                      <p className="mt-1 text-sm/6 text-gray-600/60">Sie haben Fragen zum mit XPlanung24. Anbei finden Sie eine Übersicht der häufigsten Fragen. Sofern Sie eine direkte Frage an uns richten möchten, können Sie uns unter <a className={"text-gray-900 underline font-semibold"} href={"mailTo:support@xplanung24.de"}>support@xplanung24.de</a> erreichen.</p>
                  </div>

                  <dl className=" divide-y divide-gray-300 ">
                      {faqs.map((faq) => (
                          <Disclosure key={faq.question} as="div" className={"p-6"}>
                              <dt >
                                  <Disclosure.Button className="group  flex w-full items-start justify-between text-left text-gray-900">
                                      <span className="text-sm font-semibold leading-7">{faq.question}</span>
                                      <span className="ml-6 flex h-7 items-center">
                                      <PlusSmallIcon aria-hidden="true" className="h-6 w-6 group-data-[open]:hidden" />
                                      <MinusSmallIcon aria-hidden="true" className="h-6 w-6 [.group:not([data-open])_&]:hidden" />
                                    </span>
                                  </Disclosure.Button>
                              </dt>
                              <Disclosure.Panel as="dd" className="mt-2 pr-12">
                                  <p className="text-sm leading-7 text-gray-600/60">{faq.answer}</p>
                              </Disclosure.Panel>
                          </Disclosure>
                      ))}
                  </dl>
              </div>
          </div>

      </div>

  )
}
